import React from 'react'
import NewAnimal from '../animals/NewAnimal'

export default function NewAnimalPackage(props) {
    return <NewAnimal {...props} packageMode />
}
